export default class ProductsDataProvider {
  constructor(ProductsService, db) {
    "ngInject"
    this.ProductsService = ProductsService;
    this.products = db.getCollection("products");
    this.db = db;
  }

  getProducts() {
    return this.products.find({});
  }

  loadProducts(forceReload) {
    return this.ProductsService.loadAllProducts()
      .then((products) => {
        this.products.insert(products);
        return products;
      })
  }

  loadProductMaterials(slug) {
    let
      product = this.db.getCollection('products').findOne({slug: slug}),
      service = this.ProductsService;

    return service.loadProductMaterials(product.id)
      .then((materials) => {
        product.materials = materials;
        this.products.update(product);
        return materials;
      })
  }

  loadProductMaterialsSpec(productSlug, materialSlug) {
    let
      product = this.db.getCollection('products').findOne({slug: productSlug}),
      service = this.ProductsService,
      material = product.materials.find((material) => material.slug == materialSlug);
    return service.loadProductMaterialSpec(product.id, material.id)
      .then((spec) => {
        material.spec = spec;
        this.products.update(product);
        return spec;
      })
  }

  loadProductMaterialPricing(productSlug, materialSlug) {
    let
      product = this.db.getCollection('products').findOne({slug: productSlug}),
      service = this.ProductsService,
      material = product.materials.find((material) => material.slug == materialSlug);
    return service.loadProductMaterialPricing(productSlug, materialSlug)
      .then((pricing) => {
        material.pricing = pricing;
        this.products.update(product);
        return pricing;
      })
  }

  saveProductMaterialPricing(productSlug, materialSlug, spec) {
    let
      product = this.db.getCollection('products').findOne({slug: productSlug}),
      service = this.ProductsService,
      material = product.materials.find((material) => material.slug == materialSlug);
    return service
      .saveProductMaterialPricing(productSlug, materialSlug, spec)
      .then((resp) => {
        material.pricing = spec;
        this.products.update(product);
        return resp;
      })
  }

  addProductMaterialShape(productId, materialId, shapeId) {
    let
      product = this.db.getCollection('products').findOne({id: productId}),
      service = this.ProductsService,
      material = product.materials.find((material) => material.id == materialId),
      shapes = material.spec.shapes;

    return service.addProductMaterialShape(productId, materialId, shapeId)
      .then((shape) => {
        shapes.push(shape, 1);
        this.products.update(product);
        return shape;
      })
      .catch((error) => {
        console.error(error);
      })
  }

  deleteProductMaterialShape(productId, materialId, shapeId) {
    let
      product = this.db.getCollection('products').findOne({id: productId}),
      service = this.ProductsService,
      material = product.materials.find((material) => material.id == materialId),
      shapes = material.spec.shapes,
      shapeIdx = shapes.findIndex((shape) => shape.id == shapeId);
    return service.deleteProductMaterialShape(productId, materialId, shapeId)
      .then((shape) => {
        //delete from storage on successful api call
        shapes.splice(shapeIdx, 1);
        this.products.update(product);
        return shape;
      })
      .catch((error) => {
        console.error(error);
      })
  }

  addProductMaterialColor(productId, materialId, colorId) {
    let
      product = this.db.getCollection('products').findOne({id: productId}),
      service = this.ProductsService,
      material = product.materials.find((material) => material.id == materialId),
      colors = material.spec.colors;

    return service.addProductMaterialColor(productId, materialId, colorId)
      .then((color) => {
        colors.push(color, 1);
        this.products.update(product);
        return color;
      })
      .catch((error) => {
        console.error(error);
      })
  }

  deleteProductMaterialColor(productId, materialId, colorId) {
    let
      product = this.db.getCollection('products').findOne({id: productId}),
      service = this.ProductsService,
      material = product.materials.find((material) => material.id == materialId),
      colors = material.spec.colors,
      colorIdx = colors.findIndex((color) => color.id == colorId);
    return service.deleteProductMaterialColor(productId, materialId, colorId)
      .then((color) => {
        //delete from storage on successful api call
        colors.splice(colorIdx, 1);
        this.products.update(product);
        return color;
      })
      .catch((error) => {
        console.error(error);
      })
  }

  updateName(data, type) {
    let dataS = {id: data.id, name: data.name, slug: data.slug}
    return this.ProductsService.updateName(dataS, type)
      .then((result) => {
        return result;
      })
  }

}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/services/products.dataprovider.service.js
 **/